import React, { useRef } from "react";
import {
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";

const ImageUploadArea = ({ 
  onImageUpload, 
  uploading, 
  isDragOver, 
  onDragOver, 
  onDragLeave, 
  onDrop 
}) => {
  const fileInputRef = useRef(null);

  const handleFileInputChange = (event) => {
    onImageUpload(event.target.files);
    // Reset the input value to allow selecting the same file again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Box sx={{ mb: 2 }}>
      <input
        ref={fileInputRef}
        accept="image/*"
        style={{ display: 'none' }}
        id="portfolio-image-upload"
        multiple
        type="file"
        onChange={handleFileInputChange}
        disabled={uploading}
      />
      <Box
        onClick={handleUploadClick}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        sx={{
          border: `2px dashed ${isDragOver ? '#4D6BF6' : '#D1D5DB'}`,
          borderRadius: 2,
          py: 4,
          px: 3,
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: isDragOver ? '#F8FAFF' : '#FAFAFA',
          transition: 'all 0.2s ease-in-out',
          position: 'relative',
          '&:hover': {
            borderColor: '#4D6BF6',
            backgroundColor: '#F8FAFF',
          }
        }}
      >
        {uploading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 2,
              zIndex: 1,
            }}
          >
            <CircularProgress size={40} sx={{ color: '#4D6BF6' }} />
          </Box>
        )}
        <CloudUploadIcon sx={{ fontSize: 40, color: isDragOver ? '#3B5BDB' : '#4D6BF6', mb: 1 }} />
        <Typography variant="body1" sx={{ color: isDragOver ? '#3B5BDB' : '#4D6BF6', fontWeight: 500, mb: 0.5 }}>
          {isDragOver ? 'Drop images here' : 'Click to upload or drag & drop images'}
        </Typography>
        <Typography variant="body2" sx={{ color: '#666' }}>
          PNG, JPG, (max size 1200*800)
        </Typography>
      </Box>
    </Box>
  );
};

export default ImageUploadArea;
